import { render, staticRenderFns } from "./addBorrowing.vue?vue&type=template&id=4079970c&scoped=true&"
import script from "./addBorrowing.vue?vue&type=script&lang=js&"
export * from "./addBorrowing.vue?vue&type=script&lang=js&"
import style0 from "./addBorrowing.vue?vue&type=style&index=0&id=4079970c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4079970c",
  null
  
)

export default component.exports